import { Component, Input, ElementRef, Optional, Self } from '@angular/core';
import { Observable } from 'rxjs';
import { Results, PlatformApiService, ResultFilter } from '../services/platform-api.service';
import { Account } from '../models/AccountModel';
import { InfiniteScrollSelectComponent, InfiniteScrollOption } from './infinite-scroll-select.component';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'cw-manage-user-dropdown',
  templateUrl: './infinite-scroll-select.component.html',
  styleUrls: ['./infinite-scroll-select.component.scss'],
  providers:[{provide: MatFormFieldControl, useExisting: ManageUserDropdownComponent}]
})
export class ManageUserDropdownComponent extends InfiniteScrollSelectComponent<string> {
  @Input() placeholder = 'Manage User'
  @Input() partnerAccount:Account;
  @Input() disableInUseUsers: boolean;
  @Input() MultiSelection: string;
  selectedValue: any[] = [];

  constructor(private _apiService: PlatformApiService, fm: FocusMonitor, elRef: ElementRef<HTMLElement>,
    @Optional() @Self() ngControl: NgControl) {
    super(fm, elRef, ngControl);
  }

  searchFunction(currentFilters: ResultFilter) : Observable<Results<any>> {
    return this._apiService.getManageUsers(this.partnerAccount.id, currentFilters);
  }

  mapSearchResults(results: Results<any>) {
    if(results.count > 0) {
      this.options.next(results.results.map(result => {
        return new InfiniteScrollOption(result.firstName + ' ' + result.lastName, result.externalId, this.disableInUseUsers? !!result.identifyUserId : false, false, true, result);
      }));
    } else {
      this.options.next([new InfiniteScrollOption('No results found.', null, true, false, true)]);
    }
    this.totalResults = results.count;
  }

  createResultsFilter(filter: string) {
    const resultFilter = new ResultFilter();
    if(filter[0] != '*') {
      filter = '*' + filter;
    }
    resultFilter.searchData.fullName = filter;
    return resultFilter;
  }

  optionClicked(event: Event, option) {
    event.stopPropagation();
  }

  toggleSelection(option) {}
}